import React from "react";
import { Input, Table } from "antd";
import { TransporterList } from "../../../../models/transporter";
import { EditTransporterData } from "./popups/EditTransporterData";
import { pagination } from "../../../../controller/Utils";

const Search = Input.Search

export class TransporterDataManage extends React.Component {
  state = {
    data: [],
    selectedRowKeys: [],
    pagination: pagination,
    params: {}
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({ loading: true, params: params });
    TransporterList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ...filters,
    });
  };
  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };
  onRowUpdateClick = (row_id) => {
    this.setEditVisible(true);
    this.setState({ row_id })
  };
  columns =
    [
      {
        title: 'Action',
        render: item => <div className="action-column">
          <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil" /></a>
        </div>
      },
      {
        title: 'Transporter Name',
        dataIndex: 'name',
      },
      {
        title: 'Address',
        dataIndex: 'address',
      },
      {
        title: 'City',
        dataIndex: 'city',
      },
      {
        title: 'Zip Code',
        dataIndex: 'zip_code',
      }
    ];

  componentDidMount() {
    this.fetch();
  }

  setEditVisible(editVisible) {
    this.setState({ editVisible });
    if (!editVisible)
      this.setState({ row_id: editVisible })
  }

  render() {
    const { data, selectedRowKeys, pagination } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <React.Fragment>
        <div className="col-sm-3 col-xs-12">
          <button className="btn submit-btn xs-hide" type="button"
            onClick={() => this.onRowUpdateClick()}>Create Transporter
          </button>
          <button className="btn submit-btn xs-show" type="button" onClick={item => this.onRowUpdateClick(item.id)}><i
            className="fa fa-plus" />
          </button>
        </div>
        <div className="col-sm-3 col-10 pull-xs-right">
          <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })} />
        </div>
        <div className="col-sm-3 col-12 edit-div">
          <span>{pagination.total} Records</span>
          <button className="btn btn-edit"><i className="icon-printer" /></button>
        </div>
        <div className="col-12 date-row">
          <p>Transporter Data</p>
        </div>
        <div className="col-12">
          <div className="listing-table data-manage-tbl">
            <Table rowSelection={rowSelection} columns={this.columns} dataSource={data}
              onChange={this.handleTableChange} pagination={pagination} rowKey={row => row.id}
              className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list" />
          </div>
        </div>
        <EditTransporterData fetch={() => this.fetch()} row_id={this.state.row_id} visible={this.state.editVisible}
          onClose={() => this.setEditVisible(false)} />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/transporter/TransporterDataManage.jsx